import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';

export const useBrandStore = defineStore('brand', () => {
  const {
    items: brands,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroy,
  } = createBaseStore('api/library/brand');

  return {
    brands,
    fetch,
    destroy,
    update,
    store,
  };
});
